var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 53 52"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.018 10.001H12.749c-1.306 0-2.362 1.031-2.362 2.306V39.69c0 1.275 1.056 2.312 2.362 2.312h27.269c1.306 0 2.369-1.037 2.369-2.306V12.307c0-1.275-1.063-2.306-2.369-2.306M19.881 37.27h-4.75V21.995h4.75zm-2.375-17.356a2.75 2.75 0 0 1-2.757-2.75 2.75 2.75 0 0 1 2.757-2.75 2.75 2.75 0 0 1 0 5.5m20.15 17.356h-4.744v-7.425c0-1.769-.032-4.05-2.469-4.05-2.469 0-2.844 1.931-2.844 3.925v7.55h-4.737V21.995h4.55v2.087h.062c.631-1.2 2.182-2.468 4.488-2.468 4.806 0 5.694 3.162 5.694 7.275z"
  })));
};
export default SvgLinkedin;